import OBase from './OBase';

import * as Geometry from '../geometry';

export default class Degrees extends OBase {
  update () {
    let valTree = this.getFloatInput('Radians');
    let pOutput = this.getGenericObjectOutput('Degrees');

    var outTree = new Geometry.DataTree();

    for (let i = 0; i < valTree.branches.length; i++) {
      for (let j = 0; j < valTree.branches[i].length; j++) {
        let val = valTree.branches[i][j];
        let nval = val * 180.0 / Math.PI;
        outTree.add(nval, valTree.paths[i]);
      }
    }

    pOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Degrees.js